export default {
  hero_badge: 'Centrum wiedzy i katalog zasobów',
  hero_title: 'USFans Spreadsheet — znajdź, porównaj i zbadaj zasoby',
  hero_subtitle:
    'Poznaj uporządkowane zasoby arkusza USFans, informacje o produktach, badania sprzedawców, poradniki wysyłki, opinie, porównania i praktyczne samouczki — wszystko w jednym miejscu, aby przyspieszyć Twoje poszukiwania.',
  hero_cta_primary: 'usfans spreadsheet',
  hero_cta_secondary: 'kup teraz',
  hero_hint: 'Przeglądaj produkty według kategorii lub przejdź do strony głównej',

  trust_1_title: 'Uporządkowane zasoby',
  trust_1_desc: 'Znajdź przydatne informacje w jednym, uporządkowanym miejscu.',
  trust_2_title: 'Szybsze badanie',
  trust_2_desc: 'Porównuj produkty, sprzedawców i zasoby bez straty czasu.',
  trust_3_title: 'Aktualne poradniki',
  trust_3_desc: 'Praktyczne poradniki o arkuszach, wysyłce i magazynie.',
  trust_4_title: 'Bezpieczeństwo przede wszystkim',
  trust_4_desc: 'Dowiedz się, jak oceniać linki, sprzedawców i informacje.',

  category_section_title: 'Przeglądaj produkty według kategorii',
  category_section_subtitle:
    'Wybierz kategorię, aby poznać powiązane produkty bezpośrednio na stronie głównej.',
  category_dropdown_label: 'Wybierz kategorię',
  category_dropdown_placeholder: 'Wybierz kategorię…',
  category_viewAll: 'Zobacz wszystkie kategorie',

  what_title: 'Czym jest USFans Spreadsheet?',
  what_body:
    'USFans Spreadsheet to uporządkowany sposób na organizowanie i badanie informacji o produktach, sprzedawcach i zasobach. Zamiast przeszukiwać rozproszone strony, możesz korzystać z uporządkowanych zasobów, aby odkrywać informacje, porównywać opcje i sprawniej kontynuować badania.',
  what_cta: 'Poznaj poradnik USFans Spreadsheet',

  guides_title: 'Popularne poradniki USFans Spreadsheet',
  guides_subtitle:
    'Zacznij od tych praktycznych poradników, aby zrozumieć arkusze, badania i porównania.',
  guide_1_title: 'Czym jest USFans Spreadsheet?',
  guide_1_desc: 'Proste wprowadzenie do arkuszy i ich roli w organizowaniu badań.',
  guide_2_title: 'Jak korzystać z USFans Spreadsheet',
  guide_2_desc: 'Wskazówki krok po kroku do przeglądania i porównywania zasobów.',
  guide_3_title: 'Katalog USFans Spreadsheet',
  guide_3_desc: 'Przegląd głównych obszarów zasobów i kategorii.',
  guide_4_title: 'Poradnik o sprzedawcach',
  guide_4_desc: 'Co sprawdzić, zanim zaufasz sprzedawcy lub linkowi produktu.',
  guide_5_title: 'Badanie produktów USFans',
  guide_5_desc: 'Jak sprawnie porównywać produkty i kategorie.',
  guide_6_title: 'Poradnik kosztów wysyłki',
  guide_6_desc: 'Dowiedz się, co wpływa na koszty i metody wysyłki.',
  guides_viewAll: 'Zobacz wszystkie poradniki',

  // Artykuły filarowe
  pillar_title: 'Artykuły filarowe USFans Spreadsheet',
  pillar_subtitle:
    'Poznaj naszą pełną bibliotekę szczegółowych poradników o arkuszach, produktach, sprzedawcach, wysyłce, kuponach, magazynie, recenzjach i bezpieczeństwie.',

  info_review_title: 'Opinia o USFans',
  info_review_desc:
    'Poznaj niezależny przegląd USFans: funkcje, użyteczność, potencjalne zalety i ważne uwagi.',
  info_shipping_title: 'Koszt wysyłki USFans',
  info_shipping_desc:
    'Dowiedz się, co wpływa na koszty wysyłki: metoda, waga paczki, miejsce docelowe i inne zmienne.',
  info_legit_title: 'Czy USFans jest wiarygodne?',
  info_legit_desc:
    'Zrozum, co powinieneś zweryfikować przed skorzystaniem z platformy, sprzedawcy czy linku.',
  info_cta: 'Poznaj poradniki USFans',

  compare_title: 'Porównaj, zanim zdecydujesz',
  compare_subtitle: 'Skorzystaj z tych kryteriów, aby określić, co jest dla Ciebie ważne.',
  compare_col_feature: 'Funkcja',
  compare_col_spreadsheet: 'Badanie arkusza',
  compare_col_seller: 'Badanie sprzedawcy',
  compare_r1_label: 'Głębokość informacji',
  compare_r1_a: 'Wysoka',
  compare_r1_b: 'Średnia',
  compare_r2_label: 'Łatwość użycia',
  compare_r2_a: 'Łatwa',
  compare_r2_b: 'Umiarkowana',
  compare_r3_label: 'Najlepsze do',
  compare_r3_a: 'Szczegółowych badań',
  compare_r3_b: 'Weryfikacji sprzedawców',

  safety_title: 'Centrum bezpieczeństwa USFans',
  safety_body:
    'Przed skorzystaniem z arkusza, linku produktu czy informacji o sprzedawcy poświęć chwilę na weryfikację źródła i zrozumienie ryzyka. Nasze Centrum bezpieczeństwa podpowiada, jak sprawdzać linki, sprzedawców, informacje o produktach i ryzyko związane z płatnościami.',
  safety_cta: 'Odwiedź Centrum bezpieczeństwa',

  faq_title: 'Często zadawane pytania',
  faq_subtitle: 'Szybkie odpowiedzi na najczęstsze pytania o USFans Spreadsheet.',
  faq_q1: 'Czym jest USFans Spreadsheet?',
  faq_a1:
    'USFans Spreadsheet to uporządkowany sposób na organizowanie i badanie informacji o produktach, sprzedawcach i zasobach.',
  faq_q2: 'Jak korzystać z USFans Spreadsheet?',
  faq_a2:
    'Zacznij od wybrania kategorii lub poradnika, porównaj zasoby i przejdź do strony głównej, gdy będziesz gotowy.',
  faq_q3: 'Czy USFans jest wiarygodne?',
  faq_a3:
    'Zawsze niezależnie weryfikuj sprzedawców, linki i szczegóły produktów przed podjęciem decyzji lub zakupem.',
  faq_q4: 'Ile kosztuje wysyłka USFans?',
  faq_a4:
    'Koszty zależą od metody, wagi paczki i miejsca docelowego. Sprawdź aktualne informacje na stronie głównej.',
  faq_q5: 'Gdzie znajdę kupony USFans?',
  faq_a5: 'Oferty często się zmieniają, więc sprawdź stronę główną, aby zobaczyć aktualne promocje.',
  faq_q6: 'Czym jest magazyn USFans?',
  faq_a6:
    'Magazyn dotyczy przechowywania i wysyłki produktów. Aktualne informacje znajdziesz na stronie głównej.',
  faq_q7: 'Jak sprawdzić sprzedawcę USFans?',
  faq_a7:
    'Przejrzyj szczegóły produktów, porównaj opcje i niezależnie zweryfikuj informacje, zanim zaufasz sprzedawcy.',

  final_title: 'Gotowy, aby poznać zasoby USFans Spreadsheet?',
  final_body:
    'Zacznij od uporządkowanych poradników, porównań i zasobów USFans Spreadsheet, a następnie przejdź do strony głównej, gdy będziesz gotowy na dalsze kroki.',
  final_cta_primary: 'Poznaj USFans Spreadsheet',
  final_cta_secondary: 'Odwiedź stronę główną',

  footer_tagline:
    'Niezależne źródło informacji o poradnikach, kategoriach, opiniach i badaniach USFans Spreadsheet.',
  footer_resources: 'Zasoby',
  footer_company: 'Firma',
  footer_legal: 'Informacje prawne',
  footer_guides: 'Poradniki',
  footer_reviews: 'Opinie',
  footer_shipping: 'Wysyłka',
  footer_safety: 'Bezpieczeństwo',
  footer_faq: 'FAQ',
  footer_about: 'O nas',
  footer_editorial: 'Polityka redakcyjna',
  footer_contact: 'Kontakt',
  footer_privacy: 'Polityka prywatności',
  footer_terms: 'Regulamin',
  footer_disclaimer: 'Zastrzeżenia',
  footer_languages: 'Języki',
  footer_copyright: 'USFansLink.boats — niezależne źródło informacji. Wszelkie prawa zastrzeżone.',
  footer_disclaimer_text:
    'USFansLink.boats to niezależne źródło informacji i nie jest oficjalną stroną USFans. Zawsze niezależnie weryfikuj sprzedawców, linki, produkty, ceny, informacje o wysyłce i szczegóły transakcji.',

  category_shoes: 'Buty',
  category_hoodies: 'Bluzy / Swetry',
  category_tshirts: 'Koszulki',
  category_jackets: 'Kurtki',
  category_pants: 'Spodnie / Szorty',
  category_headwear: 'Nakrycia głowy',
  category_sets: 'Zestawy',
  category_underwear: 'Bielizna',
  category_jersey: 'Koszulki sportowe',
  category_accessories: 'Akcesoria',
  category_bags: 'Torby',
  category_belts: 'Paski',
  category_perfumes: 'Perfumy',
  category_other: 'Inne rzeczy',
};